import React, { useRef } from "react";
import {
  Star,
  Quote,
  ChevronLeft,
  ChevronRight,
  Heart,
  Globe,
  Award,
  Headphones
} from "lucide-react";
import "./HoneymoonTestimonials.css";

const TESTIMONIALS_DATA = [
  {
    id: 1,
    coupleName: "Sophia & Liam Davis",
    destination: "Bora Bora, French Polynesia",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=400&q=80",
    rating: 5,
    review: "Our overwater bungalow experience was pure magic! Everything was seamlessly planned down to our private sunset dinner on the beach.",
    travelDate: "October 2025"
  },
  {
    id: 2,
    coupleName: "Ethan & Isabella Chen",
    destination: "Santorini, Greece",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
    rating: 5,
    review: "Waking up to the caldera views each morning was a dream. The local winery tours and catamaran cruise were highlights of our life.",
    travelDate: "June 2025"
  },
  {
    id: 3,
    coupleName: "Marcus & Olivia Taylor",
    destination: "Kyoto & Tokyo, Japan",
    avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=400&q=80",
    rating: 5,
    review: "From traditional ryokans in Kyoto to luxury high-rises in Tokyo, the contrast was incredible. Truly a once-in-a-lifetime honeymoon.",
    travelDate: "April 2025"
  },
  {
    id: 4,
    coupleName: "Lucas & Ava Rodriguez",
    destination: "Amalfi Coast, Italy",
    avatar: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=400&q=80",
    rating: 5,
    review: "The cliffside hotel views took our breath away! Every recommendation made by the team was spot-on. We couldn't have asked for more.",
    travelDate: "August 2025"
  }
];

const TRUST_STATS = [
  { id: 1, icon: Heart, label: "10,000+ Happy Couples" },
  { id: 2, icon: Globe, label: "50+ Destinations" },
  { id: 3, icon: Award, label: "4.9/5 Average Rating" },
  { id: 4, icon: Headphones, label: "24/7 Support" }
];

const HoneymoonTestimonials = () => {
  const trackRef = useRef(null);

  const handleScroll = (direction) => {
    if (trackRef.current) {
      const scrollAmount = direction === "left" ? -400 : 400;
      trackRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <section className="htm-section">
      <div className="htm-container">
        {/* Header Block */}
        <div className="htm-header-row">
          <div className="htm-header">
            <h2 className="htm-title">Love Stories from Our Travelers</h2>
            <p className="htm-subtitle">
              Real couples. Unforgettable journeys. Beautiful memories.
            </p>
          </div>

          {/* Navigation Controls */}
          <div className="htm-controls">
            <button
              className="htm-nav-btn"
              onClick={() => handleScroll("left")}
              aria-label="Previous Testimonials"
            >
              <ChevronLeft size={22} />
            </button>
            <button
              className="htm-nav-btn"
              onClick={() => handleScroll("right")}
              aria-label="Next Testimonials"
            >
              <ChevronRight size={22} />
            </button>
          </div>
        </div>

        {/* Carousel Track */}
        <div className="htm-track" ref={trackRef}>
          {TESTIMONIALS_DATA.map((item, index) => {
            const isFeatured = index === 0;
            return (
              <div
                key={item.id}
                className={`htm-card ${isFeatured ? "htm-card-featured" : ""}`}
              >
                {/* Background Decorator Quote */}
                <Quote className="htm-bg-quote" size={140} />

                <div className="htm-card-body">
                  {/* Rating Stars */}
                  <div className="htm-rating-row">
                    {[...Array(item.rating)].map((_, i) => (
                      <Star key={i} className="htm-star-icon" size={16} />
                    ))}
                  </div>

                  {/* Review Text */}
                  <p className="htm-review">"{item.review}"</p>

                  {/* Profile Meta */}
                  <div className="htm-profile">
                    <img
                      src={item.avatar}
                      alt={item.coupleName}
                      className="htm-avatar"
                    />
                    <div className="htm-profile-info">
                      <h3 className="htm-couple-name">{item.coupleName}</h3>
                      <p className="htm-destination">{item.destination}</p>
                      <span className="htm-date">{item.travelDate}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Trust Statistics Row */}
        <div className="htm-stats-row">
          {TRUST_STATS.map((stat) => {
            const IconComponent = stat.icon;
            return (
              <div key={stat.id} className="htm-stat-item">
                <div className="htm-stat-icon-wrapper">
                  <IconComponent size={20} className="htm-stat-icon" />
                </div>
                <span className="htm-stat-label">{stat.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HoneymoonTestimonials;